import React, { useCallback } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';

import { maxWidth } from '../configs';

const useStyles = makeStyles(theme => ({
	root: {
		marginTop: 8,
		marginBottom: 8,
		width: '100%',
		maxWidth,
		display: 'flex',
		justifyContent: 'center'
	},
	button: {
		width: 35,
		height: 35,
		margin: 5,
		opacity: 0.3,
		transition: 'all 0.2s',
	},
	selected: {
		opacity: 1,
		border: '2px solid #5f5f5f',
	}
}));

function ColorPicker(props) {
	const classes = useStyles();
	const { value, options, onChange } = props;

	const handleChange = useCallback((newColor) => (event) => {
		onChange(event, newColor);
	}, [onChange]);

	return (
		<div className={classes.root}>
			{options.map(e => (
				<IconButton 
					key={e}
					className={clsx(
						classes.button,
						e === value && classes.selected,
					)}
					onClick={handleChange(e)}
					style={{backgroundColor: e}} 
				/>
			))}
		</div>
	);
}

export default ColorPicker;
